var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('img',{staticClass:"img",attrs:{"src":require("./assets/1.png")}}),_c('div',{staticClass:"icp"},[_c('a',{attrs:{"href":"https://beian.miit.gov.cn/#/Integrated/index"}},[_vm._v("浙ICP备2024109524号")])])])
}]

export { render, staticRenderFns }